export default "__VITE_ASSET__bvJ37N7F__"